"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('../../../commons/httpClient'),
  httpClient = _require.httpClient;
var store = require('../../../../../../../config/store');
var helpers = require('../../../checkout/helpers');
var _require2 = require('../../../../../../../config/constants'),
  APPLE_PAY = _require2.APPLE_PAY;
var _require3 = require('../../initializeCheckout'),
  initializeCheckout = _require3.initializeCheckout;
var _require4 = require('../../../commons'),
  createTemporaryBasket = _require4.createTemporaryBasket;
var ApplePay = /*#__PURE__*/function () {
  function ApplePay(config, applicationInfo, adyenTranslations, isExpressPdp, initialAmount) {
    var _this = this;
    _classCallCheck(this, ApplePay);
    _defineProperty(this, "formatAddress", function (data) {
      var contact = _this[data] || {};
      var addressLines = contact.addressLines || [];
      return {
        address1: addressLines[0] || '',
        address2: addressLines.length > 1 ? addressLines[1] : null,
        city: contact.locality || '',
        countryCode: {
          displayValue: contact.country || '',
          value: contact.countryCode || ''
        },
        firstName: contact.givenName || '',
        lastName: contact.familyName || '',
        postalCode: contact.postalCode || '',
        stateCode: contact.administrativeArea || ''
      };
    });
    _defineProperty(this, "formatCustomerObject", function () {
      var customerData = _this.customerData;
      return {
        addressBook: {
          addresses: {},
          preferredAddress: _objectSpread(_objectSpread({}, _this.formatAddress('customerData')), {}, {
            ID: customerData.emailAddress
          })
        },
        billingAddressDetails: _this.formatAddress('billingData'),
        customer: {},
        profile: {
          firstName: customerData.givenName,
          lastName: customerData.familyName,
          email: customerData.emailAddress,
          phone: customerData.phoneNumber
        }
      };
    });
    _defineProperty(this, "handleAuthorised", function (response, resolve) {
      resolve({
        resultCode: response === null || response === void 0 ? void 0 : response.resultCode,
        status: _this.APPLE_PAY_SUCCESS
      });
      if (document.querySelector('#result')) {
        var _response$fullRespons, _response$fullRespons2, _response$fullRespons3, _response$fullRespons4, _response$fullRespons5, _response$fullRespons6, _response$fullRespons7;
        document.querySelector('#result').value = JSON.stringify({
          pspReference: (_response$fullRespons = response.fullResponse) === null || _response$fullRespons === void 0 ? void 0 : _response$fullRespons.pspReference,
          resultCode: (_response$fullRespons2 = response.fullResponse) === null || _response$fullRespons2 === void 0 ? void 0 : _response$fullRespons2.resultCode,
          paymentMethod: (_response$fullRespons3 = response.fullResponse) !== null && _response$fullRespons3 !== void 0 && _response$fullRespons3.paymentMethod ? response.fullResponse.paymentMethod : (_response$fullRespons4 = response.fullResponse) === null || _response$fullRespons4 === void 0 ? void 0 : (_response$fullRespons5 = _response$fullRespons4.additionalData) === null || _response$fullRespons5 === void 0 ? void 0 : _response$fullRespons5.paymentMethod,
          donationToken: (_response$fullRespons6 = response.fullResponse) === null || _response$fullRespons6 === void 0 ? void 0 : _response$fullRespons6.donationToken,
          amount: (_response$fullRespons7 = response.fullResponse) === null || _response$fullRespons7 === void 0 ? void 0 : _response$fullRespons7.amount
        });
      }
      if (document.querySelector('#showConfirmationForm')) {
        document.querySelector('#showConfirmationForm').submit();
      }
    });
    _defineProperty(this, "handleError", function (rejectApplePay) {
      rejectApplePay({
        status: _this.APPLE_PAY_ERROR
      });
      if (document.querySelector('#result')) {
        document.querySelector('#result').value = JSON.stringify({
          error: true
        });
      }
      // Do not submit the confirmation form on error — this was causing
      // orders with incomplete addresses to proceed through checkout
    });
    _defineProperty(this, "handleApplePayResponse", function (response, resolveApplePay, rejectApplePay) {
      if ((response === null || response === void 0 ? void 0 : response.resultCode) === 'Authorised') {
        _this.handleAuthorised(response, resolveApplePay);
      } else {
        _this.handleError(rejectApplePay);
      }
    });
    _defineProperty(this, "callPaymentFromComponent", function (data) {
      return httpClient({
        url: _this.paymentFromComponentURL,
        method: 'POST',
        data: {
          data: JSON.stringify(data),
          paymentMethod: APPLE_PAY
        }
      });
    });
    _defineProperty(this, "selectShippingMethod", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
        var shipmentUUID, ID, requestBody;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              shipmentUUID = _ref.shipmentUUID, ID = _ref.ID;
              requestBody = {
                paymentMethodType: APPLE_PAY,
                shipmentUUID: shipmentUUID,
                methodID: ID,
                isExpressPdp: _this.isExpressPdp
              };
              return _context.a(2, httpClient({
                method: 'POST',
                url: _this.selectShippingMethodUrl,
                data: {
                  data: JSON.stringify(requestBody)
                }
              }));
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getShippingMethod", function (shippingContact) {
      var requestBody = {
        paymentMethodType: APPLE_PAY,
        isExpressPdp: _this.isExpressPdp
      };
      if (shippingContact) {
        var addressLines = shippingContact.addressLines || [];
        requestBody.address = {
          address1: addressLines[0] || null,
          address2: addressLines.length > 1 ? addressLines[1] : null,
          city: shippingContact.locality,
          country: shippingContact.country,
          countryCode: shippingContact.countryCode,
          stateCode: shippingContact.administrativeArea,
          postalCode: shippingContact.postalCode
        };
        requestBody.firstName = shippingContact.givenName || null;
        requestBody.lastName = shippingContact.familyName || null;
        requestBody.phone = shippingContact.phoneNumber || null;
      }
      return httpClient({
        method: 'POST',
        url: _this.shippingMethodsUrl,
        data: {
          data: JSON.stringify(requestBody)
        }
      });
    });
    _defineProperty(this, "onAuthorized", function (data, actions) {
      var authorizedEvent = data.authorizedEvent;
      try {
        _this.customerData = authorizedEvent.payment.shippingContact;
        _this.billingData = authorizedEvent.payment.billingContact;
        _this.customer = _this.formatCustomerObject();
        actions.resolve();
      } catch (error) {
        actions.reject();
      }
    });
    _defineProperty(this, "onSubmit", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(state, component, actions) {
        var resolve, reject, stateData, response;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              resolve = actions.resolve, reject = actions.reject;
              stateData = _objectSpread(_objectSpread({}, state.data), {}, {
                paymentType: 'express'
              });
              _context2.n = 1;
              return _this.callPaymentFromComponent(_objectSpread(_objectSpread({}, stateData), {}, {
                customer: _this.customer,
                isExpressPdp: _this.isExpressPdp
              }));
            case 1:
              response = _context2.v;
              if (response && response.error) {
                _this.handleError(reject);
                return _context2.a(2);
              }
              helpers.createShowConfirmationForm(_this.showConfirmationAction);
              helpers.setOrderFormData(response);
              if (document.querySelector('#additionalDetailsHidden')) {
                document.querySelector('#additionalDetailsHidden').value = JSON.stringify(stateData);
              }
              _this.handleApplePayResponse(response, resolve, reject);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(this, "onShippingMethodSelected", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(resolve, reject, event) {
        var shippingMethod, shippingMethodsData, shippingMethods, matchingShippingMethod, calculationResponse, applePayShippingMethodUpdate;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              shippingMethod = event.shippingMethod;
              _context3.n = 1;
              return _this.getShippingMethod();
            case 1:
              shippingMethodsData = _context3.v;
              shippingMethods = shippingMethodsData === null || shippingMethodsData === void 0 ? void 0 : shippingMethodsData.shippingMethods;
              matchingShippingMethod = shippingMethods.find(function (sm) {
                return sm.ID === shippingMethod.identifier;
              });
              _context3.n = 2;
              return _this.selectShippingMethod(matchingShippingMethod);
            case 2:
              calculationResponse = _context3.v;
              if (calculationResponse !== null && calculationResponse !== void 0 && calculationResponse.grandTotalAmount) {
                applePayShippingMethodUpdate = {
                  newTotal: {
                    type: 'final',
                    label: _this.config.merchantName,
                    amount: calculationResponse.grandTotalAmount.value
                  }
                };
                resolve(applePayShippingMethodUpdate);
              } else {
                reject();
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x5, _x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(this, "onShippingContactSelected", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(resolve, reject, event) {
        var _shippingMethodsData$;
        var shippingContact, shippingMethodsData, selectedShippingMethod, newCalculation, shippingMethodsStructured, applePayShippingContactUpdate;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              shippingContact = event.shippingContact;
              // Validate that shipping address is US only
              if (shippingContact.countryCode !== 'US') {
                var errorAmount = '0.00';
                if (_this.amount && _this.amount.value !== undefined && _this.amount.value !== null) {
                  var amountValue = _this.amount.value;
                  // Convert to string and ensure proper decimal format
                  if (typeof amountValue === 'number') {
                    errorAmount = amountValue.toFixed(2);
                  } else {
                    errorAmount = String(amountValue);
                  }
                }
                resolve({
                  errors: [new ApplePayError('shippingContactInvalid', 'countryCode', 'Cannot ship outside the United States')],
                  newTotal: {
                    type: 'final',
                    label: _this.config.merchantName,
                    amount: errorAmount
                  }
                });
                _context4.n = 4;
                break;
              }
              _context4.n = 1;
              return _this.getShippingMethod(shippingContact);
            case 1:
              shippingMethodsData = _context4.v;
              if (!(shippingMethodsData !== null && shippingMethodsData !== void 0 && (_shippingMethodsData$ = shippingMethodsData.shippingMethods) !== null && _shippingMethodsData$ !== void 0 && _shippingMethodsData$.length)) {
                _context4.n = 3;
                break;
              }
              selectedShippingMethod = shippingMethodsData.shippingMethods[0];
              _context4.n = 2;
              return _this.selectShippingMethod(selectedShippingMethod);
            case 2:
              newCalculation = _context4.v;
              if (newCalculation !== null && newCalculation !== void 0 && newCalculation.grandTotalAmount) {
                shippingMethodsStructured = shippingMethodsData.shippingMethods.map(function (sm) {
                  return {
                    label: sm.displayName,
                    detail: sm.description,
                    identifier: sm.ID,
                    amount: "".concat(sm.shippingCost.value)
                  };
                });
                applePayShippingContactUpdate = {
                  newShippingMethods: shippingMethodsStructured,
                  newTotal: {
                    type: 'final',
                    label: _this.config.merchantName,
                    amount: newCalculation.grandTotalAmount.value
                  }
                };
                resolve(applePayShippingContactUpdate);
              } else {
                reject();
              }
              _context4.n = 4;
              break;
            case 3:
              reject();
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function (_x8, _x9, _x0) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(this, "onClick", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(resolve, reject) {
        var tempBasketResponse, applePayAmountUpdate;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!_this.isExpressPdp) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return createTemporaryBasket();
            case 1:
              tempBasketResponse = _context5.v;
              if (tempBasketResponse !== null && tempBasketResponse !== void 0 && tempBasketResponse.temporaryBasketCreated) {
                applePayAmountUpdate = {
                  newTotal: {
                    type: 'final',
                    label: _this.config.merchantName,
                    amount: tempBasketResponse.amount.value
                  }
                };
                resolve(applePayAmountUpdate);
              } else {
                reject();
              }
              _context5.n = 3;
              break;
            case 2:
              resolve();
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      return function (_x1, _x10) {
        return _ref6.apply(this, arguments);
      };
    }());
    var _window = window,
      basketAmount = _window.basketAmount,
      showConfirmationAction = _window.showConfirmationAction,
      shippingMethodsUrl = _window.shippingMethodsUrl,
      selectShippingMethodUrl = _window.selectShippingMethodUrl,
      paymentFromComponentURL = _window.paymentFromComponentURL;
    this.store = store;
    this.helpers = helpers;
    this.amount = initialAmount || JSON.parse(basketAmount);
    this.showPayButton = true;
    this.isExpress = true;
    this.isExpressPdp = isExpressPdp;
    this.paymentFromComponentURL = paymentFromComponentURL;
    this.showConfirmationAction = showConfirmationAction;
    this.shippingMethodsUrl = shippingMethodsUrl;
    this.selectShippingMethodUrl = selectShippingMethodUrl;
    this.applicationInfo = applicationInfo;
    this.config = config;
    this.customerData = null;
    this.billingData = null;
    this.translations = adyenTranslations;
    this.APPLE_PAY_SUCCESS = 1;
    this.APPLE_PAY_ERROR = 0;
  }
  return _createClass(ApplePay, [{
    key: "getConfig",
    value: function getConfig() {
      return {
        configuration: this.config,
        showPayButton: this.showPayButton,
        amount: this.amount,
        isExpress: this.isExpress,
        requiredShippingContactFields: ['postalAddress', 'email', 'phone'],
        requiredBillingContactFields: ['postalAddress', 'phone'],
        onSubmit: this.onSubmit,
        onClick: this.onClick,
        onAuthorized: this.onAuthorized,
        onShippingMethodSelected: this.onShippingMethodSelected,
        onShippingContactSelected: this.onShippingContactSelected
      };
    }
  }, {
    key: "getComponent",
    value: function () {
      var _getComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var checkout, applePayConfig;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return initializeCheckout(this.applicationInfo, this.translations);
            case 1:
              checkout = _context6.v;
              applePayConfig = this.getConfig();
              return _context6.a(2, window.AdyenWeb.createComponent(APPLE_PAY, checkout, applePayConfig));
          }
        }, _callee6, this);
      }));
      function getComponent() {
        return _getComponent.apply(this, arguments);
      }
      return getComponent;
    }()
  }]);
}();
module.exports = ApplePay;